import { wplToken } from "@atlassiansox/wpl-token";
// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { PropsWithChildren } from "react";

import { WacAppSwitcherProps } from "../app-switcher";

export interface StyledAppSwitcherIconProps extends WacAppSwitcherProps {
    toggleSwitcherDropdown: (param: boolean) => void;
    setHasHovered: (param: boolean) => void;
}
export const StyledAppSwitcherIcon = ({
    appSwitcherLabel,
    allowJoinSitesProvider,
    toggleSwitcherDropdown,
    setHasHovered,
    children
}: PropsWithChildren<Omit<StyledAppSwitcherIconProps, "isUserLoggedIn">>) => {
    return (
        <div
            tabIndex={0}
            className={"text-label-parent"}
            data-label={appSwitcherLabel}
            onClick={() => {
                toggleSwitcherDropdown(allowJoinSitesProvider);
            }}
            onKeyDown={(e) => {
                if (e.code == "Enter") {
                    toggleSwitcherDropdown(allowJoinSitesProvider);
                }
            }}
            onFocus={() => setHasHovered(true)}
            onMouseEnter={() => setHasHovered(true)}
            css={styledAppSwitcherIconStyle}
            data-testid="global-nav-styled-app-switcher-icon"
        >
            {children}
        </div>
    );
};

const styledAppSwitcherIconStyle = css`
    span {
        height: 28px;
        width: 28px;
    }
    display: flex;
    justify-content: center;
    cursor: pointer;

    &.text-label-parent {
        display: flex;
        align-items: center;
        border: 1px solid #0052cc;
        padding: 0 10px 0 14px;
        border-radius: ${wplToken("space.075")};

        &:before {
            content: attr(data-label);
            margin: 0 ${wplToken("space.075")} 0 0;
            color: #0052cc;
            font-size: 0.875rem;
            line-height: 2.15;
        }

        & > span {
            width: ${wplToken("space.300")};
            height: ${wplToken("space.300")};
        }
    }
`;
